import { Spin, Typography } from 'antd'
import { CardHeader, SectionCard } from '@/shared/ui/layout/styled'
import { Icon } from '@/shared/ui/Icon/Icon'
import { Account, AccountsGrid } from '@/widgets/accountsGrid'
const { Title } = Typography

interface IProps {
  accounts: Account[]
  selected: string[]
  onSelect: (selectedAccounts: string[]) => void
  isTransfering: boolean
  isLoading?: boolean
  currentPage?: number
}

export const GsGridTransferEntites = ({
  accounts,
  selected,
  onSelect,
  isTransfering,
  isLoading,
  currentPage,
}: IProps) => {
  const handleAccountSelect = (id: string) => {
    if (selected.includes(id)) {
      onSelect(selected.filter((selectedId) => selectedId !== id))
      return
    }
    onSelect([...selected, id])
  }

  return (
    <SectionCard>
      <CardHeader gap={8}>
        <Icon name="transfer_title" size={32} />
        <Title level={2}>Выбор данных для переноса</Title>
      </CardHeader>

      <Spin spinning={isTransfering}>
        <AccountsGrid
          accounts={accounts}
          searchLabel="Клиенты"
          selectedAccounts={selected}
          onAccountSelect={handleAccountSelect}
          isLoading={isLoading}
          currentPage={currentPage}
        />
      </Spin>
    </SectionCard>
  )
}
